﻿import React from "react";
import { DotLegalMultiSelect, IDotLegalMultiSelect } from "@dotlegal/dotlegal-ui-components";
import { SelectableItem } from "../../../processingActivity/ProcessingActivity.types";
import { useTranslation } from "../../../localization/useTranslation.ts";

import { useDotLegalQuery } from "@common/hooks/dotLegalReactQuery";

export interface IDotLegalMultiSelectApiProps<T> extends Omit<IDotLegalMultiSelect, "options" | "isLoading" | "renderOptions" | "onChange" | "noOptionsLabel"> {
    url: string;
    onChange: (items: Array<T>) => void;
    noOptionsLabel?: string;
}

function DotLegalMultiSelectApi<T extends SelectableItem>(props: IDotLegalMultiSelectApiProps<T>) {
    const { translateString } = useTranslation();
    const { isLoading, data } = useDotLegalQuery<Array<T>>(props.url);
    return (
        <DotLegalMultiSelect
            {...props}
            onChange={(strings) => {
                let items = data!.filter((d) => strings.includes(d.id));
                return props.onChange(items);
            }}
            isLoading={isLoading}
            options={data}
            noOptionsLabel={props.noOptionsLabel ?? translateString("noOptions")}
        />
    );
}

export default DotLegalMultiSelectApi;
